import { auth0ApiClient } from './auth0ApiClient'
import { CuratedFeedTopic } from './curatedSourceService'

export interface FeedTopicPreferences {
  userId: string
  subscribedTopics: CuratedFeedTopic[]
}

class FeedTopicPreferencesService {
  private readonly baseUrl = '/feed/curated/preferences'

  async getPreferences(): Promise<FeedTopicPreferences> {
    return auth0ApiClient.get<FeedTopicPreferences>(this.baseUrl)
  }

  async updatePreferences(subscribedTopics: CuratedFeedTopic[]): Promise<FeedTopicPreferences> {
    return auth0ApiClient.put<FeedTopicPreferences>(this.baseUrl, { subscribedTopics })
  }
}

export const feedTopicPreferencesService = new FeedTopicPreferencesService()
